module.exports = __webpack_public_path__ + "img/p13.8deb16e4.png";